<template>
	<v-dialog v-model="setdialog.dialog" max-width="1500px" persistent content-class="common-modal">
		<v-card class="dialog">
			<!-- 내용 -->
			<v-layout class="title px-4" :style="`background-color:${$store.state.PointColor9}; height:56px;`" align-center>
				<!-- text -->
				<h2 class="white--text">{{ type ? '상담고객' : '등록고객' }} 정보</h2>
				<v-spacer />
				<!-- icon -->
				<v-icon @click="setdialog.dialog = false" color="white" class="title-icon" large>mdi-close</v-icon>
			</v-layout>

			<!-- 버튼 -->
			<div class="dialog-content px-4 pt-4">
				<v-layout align-end>
					<div>
						<p class="userHistory mb-1">고객명 | {{ setdialog.name }}</p>
						<p class="userHistory mb-0">전화번호 | {{ setdialog.phone }}</p>
					</div>
					<v-spacer />
					<btn @click="userExport" btn_txt="EXPORT" :btn="saveBtn"> </btn>
				</v-layout>
				<datatable :datatable="setdialog.datatable" class="tbl-type01" :imgDialogShow="imgDialogShow"> </datatable>
				<!-- bottom -->
				<div class="pb-4">
					<v-layout justify-end>
						<btn btn_txt="ok" class="ml-2" :btn="saveBtn" @click="close"></btn>
					</v-layout>
				</div>
			</div>
		</v-card>
		<alertModal2 :setdialog="imgDialog"></alertModal2>
	</v-dialog>
</template>

<script>
import { btn, datatable, alertModal2 } from '@/components/index'
export default {
	data() {
		return {
			saveBtn: {
				dark: true,
				class: 'save',
				color: '#202840',
			},
			imgDialog: {
				dialog: false,
				text: '',
			},
		}
	},
	props: {
		setdialog: Object,
		userExport: Function,
		type: String,
	},
	methods: {
		close() {
			this.setdialog.dialog = false
		},
		imgDialogShow() {
			this.imgDialog.dialog = true
		},
	},
	created() {},
	components: {
		btn,
		datatable,
		alertModal2,
	},
}
</script>
<style lang="scss" scoped>
.alertdialog {
	.title {
		height: 60px;
		display: flex;
		align-items: center;
		// background-color: #fdc85a;
		padding: 0 25px;

		h2 {
			color: white;
		}

		.title-icon {
			color: white;
		}
	}

	.dialog-content {
		padding: 40px;
		font-weight: bold;
	}
	.bottom {
		display: flex;
		margin-top: 20px;
	}
}
.red-dot {
	font-size: 24px;
	color: #ff5252;
	margin-right: 10px;
}
.userHistory {
	font-size: 18px;
	font-weight: bold;
}
</style>
